// Swiper is imported already

if (!customElements.get('product-detail-swiper')) {
  class ProductDetailSwiper extends HTMLElement {
    constructor() {
      super();

      this.swiperElement = this.querySelector('[data-product-detail-swiper]');

      this.swiperOptions = {
        direction: 'horizontal',
        threshold: 10,
      };

      this.init();
    }

    init() {
      window.addEventListener('load', (event) => {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      });
      Fancybox.bind('[data-fancybox]', {
        animated: false,
        showClass: false,
        mainClass: 'image-zoom',
      });
    }
  }

  customElements.define('product-detail-swiper', ProductDetailSwiper);
}

if (!customElements.get('product-info')) {
  class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.productForm = this.querySelector('product-form');
      this.productFormQuantity = this.productForm?.querySelector('input[name="quantity"]');
      this.quantityInput = this.querySelector('quantity-input');
      this.quantityInputElement = this.quantityInput?.querySelector('input[name="quantity"]');
      this.quantityInputElement?.addEventListener('change', () => {
        this.handleQuantityInput();
      });
      const popupTrigger = document.querySelector('[data-popup-trigger]');
      const popupContent = document.querySelector('[data-popup-content]');
      const popupBackdrop = document.querySelector('[data-popup-backdrop]');
      const popupClose = document.querySelector('[data-popup-close]');
      const body = document.querySelector('body');
      function togglePopupVisibility() {
        if (popupContent) {
          popupContent.classList.toggle('hidden');
          popupContent.classList.toggle('flex');
          body.classList.toggle('overflow-hidden'); // Prevent scrolling when popup is open
        }
      }
      if (popupTrigger && popupContent) {
        popupTrigger.addEventListener('click', togglePopupVisibility);
      }

      if (popupClose) {
        popupClose.addEventListener('click', togglePopupVisibility);
      }

      if (popupBackdrop) {
        popupBackdrop.addEventListener('click', togglePopupVisibility);
      }
    }

    /**
     * handleQuantityInput
     * @description Set the quantity from the quantity input web component to the product form web component.
     */
    handleQuantityInput() {
      this.productFormQuantity.value = this.quantityInputElement.value;
    }
  }
  customElements.define('product-info', ProductInfo);
}
